import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import AppointmentPage from '@/pages/appointment/page';
import ResourcesPage from '@/pages/resources/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/book-appointment', element: <AppointmentPage /> },
  { path: '/patient-resources', element: <ResourcesPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
